// Mock data for BAAN MAE restaurant clone (TheFork-style)

export const restaurant = {
  name: "BAAN MAE",
  cuisine: "Thaïlandais",
  avgPrice: 34,
  address: "58 Rue du Général Leclerc, 78380, Bougival",
  rating: 9.6,
  reviewsCount: 2038,
  recentReviews: 24,
  tagline: "Meilleur Hôte",
  description:
    "BAAN MAE : cadre thaï raffiné, cuisine délicieuse et épicée aux produits frais, service exceptionnel et propriétaire passionné.",
  scores: {
    plats: 9.7,
    service: 9.6,
    ambiance: 9.3,
  },
  highlights: [
    "Saveurs incroyables et plats succulents",
    "Accueil chaleureux et passionné",
    "Ambiance chaleureuse et conviviale",
  ],
  aiSummary:
    "BAAN MAE séduit par son ambiance chaleureuse et son cadre joliment décoré qui transporte en Thaïlande. La cuisine thaïlandaise est un véritable délice, avec des plats savoureux comme le bœuf sauté et le poulet curry vert. Les desserts, comme le riz à la mangue, sont parfaits. Le service est exceptionnel, avec un accueil chaleureux et un propriétaire passionné qui partage l'histoire des plats. Une adresse à recommander vivement pour un voyage culinaire inoubliable.",
  features: [
    { label: "Type de cuisine", value: "Thaïlandais" },
    { label: "Prix moyen", value: "36 €" },
    { label: "Choix alimentaires", value: "Produits locaux" },
  ],
  amenities: [
    "Salle privatisable pour 8 pers.",
    "Salle restaurant",
    "Interdit aux animaux",
    "Accès personnes à mobilité réduite",
  ],
  paymentMethods: ["Visa", "Mastercard", "American Express"],
  languages: ["Français"],
  hours: [
    { day: "Lundi", time: "19:00 - 22:30" },
    { day: "Mardi", time: "19:00 - 22:30" },
    { day: "Mercredi", time: "19:00 - 22:30" },
    { day: "Jeudi", time: "19:00 - 22:30" },
    { day: "Vendredi", time: "19:00 - 22:30" },
    { day: "Samedi", time: "19:00 - 22:30" },
    { day: "Dimanche", time: "12:00 - 14:30" },
  ],
};

export const photos = [
  "/photos/vitrine.jpg",
  "/photos/p4.jpg",
  "/photos/p1.jpg",
  "/photos/p3.jpg",
  "/photos/p2.jpg",
  "/photos/n1.jpg",
  "/photos/n2.jpg",
  "/photos/n3.jpg",
  "/photos/n4.jpg",
  "/photos/n5.jpg",
  "/photos/n6.jpg",
  "/photos/n7.jpg",
];

export const menu = {
  Entrées: {
    priceHint: "Toutes les entrées à 12 €",
    items: [
      { name: "Salade de papaye", price: 12 },
      { name: "Soupe tom yam (crevettes ou poulet)", price: 12 },
      { name: "Carpaccio de saumon", price: 12 },
      { name: "Carpaccio de crevettes", price: 12 },
      { name: "Carpaccio de thon", price: 12 },
      { name: "Salade de bœuf maison", price: 12 },
    ],
    note: "Demandez les suggestions du jour",
  },
  Plats: {
    priceHint: "Tous les plats à 24 €",
    items: [
      { name: "Pad thaï aux légumes (crevettes)", price: 24, signature: true },
      { name: "Bœuf sauté (recette maison)", price: 24, signature: true },
      { name: "Canard sauté (recette maison)", price: 24 },
      { name: "Mijoté curry rouge (crevettes ou poulet)", price: 24 },
      { name: "Mijoté curry vert (crevettes ou poulet)", price: 24, signature: true },
      { name: "Curry paneng mou (cochon)", price: 24 },
    ],
    note: "Demandez les suggestions du jour",
  },
  Desserts: {
    priceHint: "Tous les desserts à 12 €",
    items: [
      { name: "Nems croustillants banane et chocolat", price: 12 },
      { name: "Flan maison", price: 12 },
      { name: "Riz à la mangue", price: 12 },
      { name: "Saccou à la mangue (tapioca)", price: 12 },
      { name: "Graines de CHIA à la mangue", price: 12 },
      { name: "Mangue entière", price: 12, suffix: "supplément 10 €" },
    ],
    note: "Demandez les suggestions du jour",
  },
  "Cave à vins": {
    groups: [
      {
        title: "Blanc — bouteille",
        items: [
          { name: "Pouilly Fumé", price: 52 },
          { name: "Viognier", price: 36 },
          { name: "Chablis 1er cru", price: 80 },
          { name: "Menetou-Salon", price: 48 },
          { name: "Muscadet", price: 29 },
        ],
      },
      {
        title: "Rosé — bouteille",
        items: [
          { name: "Côtes de Provence", price: 29 },
          { name: "Ramatuelle", price: 36 },
          { name: "Terra Vecchia", price: 54 },
        ],
      },
      {
        title: "Rouge — bouteille",
        items: [
          { name: "Bordeaux", price: 35 },
          { name: "Côtes du Rhône", price: 29 },
          { name: "Côtes du Rhône Guigal", price: 46 },
          { name: "Sancerre", price: 50 },
          { name: "Pommard", price: 180 },
          { name: "Bourgogne", price: 58 },
        ],
      },
      {
        title: "Blanc au verre",
        items: [
          { name: "Pouilly Fumé", price: 10 },
          { name: "Viognier", price: 9 },
          { name: "Chablis 1er cru", price: 14 },
          { name: "Muscadet (sec)", price: 9 },
        ],
      },
      {
        title: "Rosé au verre",
        items: [{ name: "Côtes de Provence", price: 9 }],
      },
      {
        title: "Rouge au verre",
        items: [
          { name: "Bordeaux", price: 9 },
          { name: "Côtes du Rhône", price: 9 },
          { name: "Bourgogne", price: 10 },
        ],
      },
    ],
    note: "Demandez le vin du mois",
  },
  "Apéritifs & Champagnes": {
    items: [
      { name: "Martini blanc", price: 9 },
      { name: "Martini rouge", price: 9 },
      { name: "Kir vin blanc", price: 9 },
      { name: "Kir royal", price: 12 },
      { name: "Porto", price: 9 },
      { name: "Ricard", price: 9 },
      { name: "Coupe de champagne", price: 10 },
      { name: "Cocktail BAAN MAE", price: 12, signature: true },
      { name: "Whisky", price: 10 },
      { name: "Bouteille de champagne", price: 98 },
      { name: "Champagne Roederer", price: 200 },
    ],
  },
  Softs: {
    items: [
      { name: "Bières", price: 8 },
      { name: "Jus de fruits", price: 7 },
      { name: "Coca", price: 7 },
      { name: "Thé glacé", price: 7 },
      { name: "Eau — bouteille", price: 8 },
      { name: "Eau — demi-bouteille", price: 4 },
    ],
  },
  "Boissons chaudes": {
    items: [
      { name: "Thé", price: 7 },
      { name: "Kusmi Tea", price: 9 },
      { name: "Café", price: 3.5 },
    ],
    note: "Demandez notre carte de whiskys & rhums",
  },
};

export const formulas = [
  {
    title: "Formule Prestige",
    subtitle: "Entrée + Plat ou Plat + Dessert",
    price: 44,
    priceLabel: "44 € par personne",
    accent: "#9B4E2A",
    sections: [
      {
        title: "Entrée",
        items: [
          "Salade de crevettes",
          "Carpaccio de Saint-Jacques (selon arrivage)",
          "Carpaccio de saumon",
        ],
      },
      {
        title: "Plat",
        items: [
          "Le tigre qui pleure (Black Angus)",
          "Poisson croustillant (cabillaud)",
          "Gambas au curry vert",
          "Pad thaï gambas",
          "Bo bun gambas",
          "Curry vert requin (selon arrivage)",
        ],
      },
      {
        title: "Dessert",
        items: [
          "Riz à la mangue",
          "Chia à la mangue",
          "Saccou à la mangue (billes de tapioca)",
          "Nems banane, sauce chocolat",
          "Flan thaï",
          "Mangue entière (supplément 10 €)",
        ],
      },
    ],
  },
  {
    title: "Formule Découverte",
    subtitle: "Entrée + Plat + Dessert",
    price: 39,
    priceLabel: "39 € par personne",
    accent: "#1B7B71",
    sections: [
      {
        title: "Entrée",
        items: [
          "Salade de papaye",
          "Soupe tom yam crevettes",
          "Carpaccio de thon frais",
          "Salade de bœuf",
        ],
      },
      {
        title: "Plat",
        items: [
          "Pad thaï crevettes",
          "Bœuf sauté thaï maison",
          "Canard sauté thaï maison",
          "Mijoté curry rouge crevettes",
          "Mijoté curry vert crevettes",
        ],
      },
      {
        title: "Dessert",
        items: [
          "Riz à la mangue",
          "Chia à la mangue",
          "Saccou à la mangue",
          "Nems banane sauce chocolat",
          "Flan thaï",
          "Mangue entière (supplément 10 €)",
        ],
      },
    ],
  },
  {
    title: "Entrée + Plat",
    price: 28,
    priceLabel: "28 € par personne",
    accent: "#4B8B7E",
    sections: [
      {
        title: "Entrée",
        items: [
          "Nems légumes",
          "Soupe Tom yam poulet",
          "Carpaccio de crevettes",
        ],
        note: "D'autres entrées disponibles sur ardoise",
      },
      {
        title: "Plat",
        items: [
          "Porc sauté thaï maison",
          "Pad thaï légumes",
          "Bo bun légumes",
        ],
        note: "D'autres plats disponibles sur ardoise",
      },
    ],
  },
  {
    title: "Plat + Dessert",
    price: 34,
    priceLabel: "34 € par personne",
    accent: "#D14318",
    sections: [
      {
        title: "Plat",
        items: [
          "Bœuf sauté thaïlandais recette maison",
          "Pad thaï aux crevettes",
          "Mijoté de curry vert aux crevettes",
          "Massaman poulet",
        ],
        note: "D'autres plats disponibles sur ardoise",
      },
      {
        title: "Dessert",
        items: [
          "Flan thaïlandais maison",
          "Riz gluant à la mangue fraîche",
          "Nems croustillants, bananes et sauce chocolat",
          "Graines de CHIA à la mangue fraîche",
        ],
        note: "D'autres desserts disponibles sur ardoise",
      },
    ],
  },
];

export const reviews = [
  { name: "Romain S.", date: "Il y a 1 jour", rating: 10, text: "Super moment en famille. Cocktail de la maison est splendide. Toute la carte nous a été expliquée afin de ne rien rater. Entrées et plats magnifiques. Service à la perfection. Merci Monsieur pour ce beau moment passé chez vous." },
  { name: "Karim S.", date: "Il y a 7 jours", rating: 9.5, text: "Des plats au reflet de la passion du cuistot/serveur." },
  { name: "Brigitte D.", date: "Il y a 2 jours", rating: 10, text: "Une belle découverte." },
  { name: "Richard L.", date: "Il y a 2 jours", rating: 10, text: "Comme lors de notre précédent repas, l'accueil est parfait, les plats sont excellents et le patron est d'une gentillesse." },
  { name: "Valerie L.", date: "Il y a 7 jours", rating: 10, text: "Toujours tellement savoureux ! Un régal !" },
  { name: "Jean-Claude C.", date: "Il y a 24 jours", rating: 10, text: "Deuxième fois au BAAN MAE, l'accueil est parfait et les plats délicieux." },
  { name: "Théo L.", date: "Il y a 8 jours", rating: 10, text: "Comme toujours, super accueil, repas délicieux !" },
  { name: "Olivier G.", date: "Il y a 10 jours", rating: 9.5, text: "Tout était parfait." },
  { name: "Angélique C.", date: "Il y a 13 jours", rating: 10, text: "Moment très agréable : nourriture délicieuse et service impeccable. Je recommande sans hésiter :)" },
  { name: "Bernard L.", date: "Il y a 14 jours", rating: 10, text: "Une superbe découverte." },
  { name: "Noëlle M.", date: "Il y a 24 jours", rating: 10, text: "Toujours un plaisir pour nos papilles de venir chez vous." },
  { name: "Catherine M.", date: "Il y a 24 jours", rating: 10, text: "Accueil empressé, respectueux et chaleureux. Mets succulents. Ambiance conviviale, chaleureuse." },
];

export const similarRestaurants = [
  { name: "LE CAMELIA", rating: 9.3, city: "78380, Bougival", cuisine: "Français", price: 45, discount: 20, badge: "Meilleur Hôte", img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80" },
  { name: "La Parenthèse Verte", rating: 9.4, city: "78430, Louveciennes", cuisine: "Français", price: 51, badge: "Insider", img: "https://images.unsplash.com/photo-1466978913421-dad2ebd01d17?w=600&q=80" },
  { name: "Le Village", rating: 8.2, city: "78290, Croissy", cuisine: "Français", price: 24, img: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600&q=80" },
  { name: "Mangalore Lounge", rating: 9.0, city: "78170, La Celle-Saint-Cloud", cuisine: "Indien", price: 25, img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=600&q=80" },
  { name: "Chou de Chanorier", rating: 9.2, city: "78290, Croissy-sur-Seine", cuisine: "Cuisine traditionnelle", price: 35, discount: 50, img: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80" },
  { name: "Soleil Levant", rating: 8.8, city: "78560, Le Port-Marly", cuisine: "Japonais", price: 25, img: "https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=600&q=80" },
  { name: "Haveli", rating: 9.5, city: "92500, Rueil-Malmaison", cuisine: "Indien", price: 33, discount: 20, img: "https://images.unsplash.com/photo-1574484284002-952d92456975?w=600&q=80" },
  { name: "LE NARVAL", rating: 9.3, city: "78160, Marly-le-Roi", cuisine: "Vietnamien", price: 18, img: "https://images.unsplash.com/photo-1582878826629-29b7ad1cdc43?w=600&q=80" },
];

export const tags = [
  "Cosy", "Déjeuner", "En famille", "Repas d'affaires", "Romantique", "Traditionnel",
  "Fête des Mères", "Fête des Pères", "Noël", "Saint-Valentin",
  "Pad Thai", "Poulet", "Thaïlandais", "Asiatique", "Produits locaux",
  "Accès personnes à mobilité réduite", "Privatisable",
];
